export const RESELLERS = {
  MOSS_AUTO: '447',
};
